import {
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
} from "@mui/material/colors";

export const randomColor = (values: any) => {
  const value = [
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900,
    "A100",
    "A200",
    "A400",
    "A700",
  ];
  const selected = value[Math.floor(Math.random() * value.length)];

  return values[selected];
};

export const randomColorValue = () => {
  const value = [
    red,
    pink,
    purple,
    deepPurple,
    indigo,
    blue,
    lightBlue,
    cyan,
    teal,
    green,
    lightGreen,
    lime,
    yellow,
    amber,
    orange,
    deepOrange,
  ];
  const selected: any = value[Math.floor(Math.random() * value.length)];

  return selected;
};
